var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white w-full rounded-lg my-3 px-4 py-2.5"
  }, [_c('nav', {
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "flex items-center mb-2.5 gap-2.5 leading-none"
  }, [_vm.items.length === 1 ? [_c('li', {
    staticClass: "active text-gray-700 text-sm font-medium capitalize"
  }, [_vm._v(_vm._s(_vm.items[0].label))])] : _vm.items.length === 2 ? [_c('li', [_c('router-link', {
    staticClass: "text-gray-700 text-sm font-medium capitalize",
    attrs: {
      "to": _vm.items[0].to
    }
  }, [_vm._v(_vm._s(_vm.items[0].label))])], 1), _vm._m(0), _c('li', {
    staticClass: "text-gray-500 font-medium text-sm capitalize"
  }, [_vm._v(_vm._s(_vm.items[1].label))])] : _vm._l(_vm.items, function (item, idx) {
    return _c('li', {
      key: idx,
      staticClass: "flex items-center"
    }, [idx < _vm.items.length - 1 ? [_c('router-link', {
      staticClass: "active text-gray-700 text-sm font-medium capitalize",
      attrs: {
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._m(1, true)] : [_c('span', {
      staticClass: "text-gray-500 font-normal capitalize"
    }, [_vm._v(_vm._s(item.label))])]], 2);
  })], 2)]), _c('h4', {
    staticClass: "text-xl font-semibold text-gray-900 m-0 capitalize"
  }, [_vm._v(_vm._s(_vm.title))])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "text-gray-400 text-xs font-normal"
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-right"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "mx-2 text-gray-500 text-xs font-normal"
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-right"
  })]);
}]

export { render, staticRenderFns }